import React, { useMemo } from "react";
import { SortColumnsConfig, SortDirection, Tooltip } from "frno-react";
import useTextStore from "../../../../state/TextStore";

export default function useSavingsProfileTableConfig() {
  const { getTextByKey } = useTextStore();

  const headers = [
    {
      columnKey: "savings_profile",
      columnName: getTextByKey(
        "page.common.table.header.desktop.savingsprofile",
      ),
      tooltip: (
        <Tooltip
          title={getTextByKey(
            "page.common.table.header.desktop.savingsprofile",
          )}
          content={getTextByKey("page.common.table.tooltip.savingsprofile")}
        ></Tooltip>
      ),
    },
    {
      columnKey: "company",
      columnName: getTextByKey("page.common.table.header.desktop.company"),
    },
    {
      columnKey: "return",
      columnName: getTextByKey("page.common.table.header.desktop.return"),
      tooltip: (
        <Tooltip
          title={getTextByKey("page.common.table.header.desktop.return")}
          content={getTextByKey("page.common.table.tooltip.return")}
        ></Tooltip>
      ),
    },
    {
      columnKey: "risk",
      columnName: getTextByKey("page.common.table.header.desktop.risk"),
      tooltip: (
        <Tooltip
          title={getTextByKey("page.common.table.header.desktop.risk")}
          content={getTextByKey("page.common.table.tooltip.risk")}
        ></Tooltip>
      ),
    },
    {
      columnKey: "total_fee",
      columnName: getTextByKey("page.common.table.header.desktop.totalfee"),
      tooltip: (
        <Tooltip
          title={getTextByKey("page.common.table.header.desktop.totalfee")}
          content={getTextByKey("page.common.table.tooltip.totalfee")}
        ></Tooltip>
      ),
    },
  ];

  const sortableColumnsConfig: SortColumnsConfig[] = useMemo(
    () =>
      headers.map((header) => ({
        columnKey: header.columnKey,
        defaultSortDirection:
          header.columnKey === "return"
            ? SortDirection.DESCENDING
            : SortDirection.ASCENDING,
      })),
    [headers],
  );

  return { headers, sortableColumnsConfig };
}
